import React, { useState, useEffect, useRef, useCallback } from "react";
import { UNIFIED_URL } from "./Constant";
import KeySegmentTable from "./KeySegmentTable";
import styles from '../css/keysegment.module.css'

function Intent_Segment(props) {
  const [intentFilterBodyToAH, setIntentFilterBodyToAH] = useState([]);
  const [intentResult, setIntentResult] = useState([]);
  const controllerRefIntent = useRef();

  const displayIntentData = useCallback(
    async (intentFillBody) => {
      console.log("filBody in disp is", intentFillBody);
      if (controllerRefIntent.current) {
        controllerRefIntent.current.abort();
      }
      const controller = new AbortController();
      controllerRefIntent.current = controller;

      await fetch(
        `${UNIFIED_URL}/analytics/keySegment/surge/${props.tenantId}?page=1&limit=5&icp=${props.icpSelected}&filterName=${encodeURIComponent(props.segmentName)}&sortby=&sortType=`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ filters: intentFillBody }),
          signal: controllerRefIntent.current?.signal,
          credentials: "include",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.success === true) {
            setIntentResult(data?.data?.result.slice(0, 5));
            props.setCount(data?.data?.filteredCount)
          } else {
            setIntentResult([]);
            props.setCount('0')
          }
        })
        .catch((error) => {
          if (error?.message !== "The user aborted a request.") {
            setIntentResult([]);
            props.setCount('0')
            console.log(error);
          }
        });
    },
    [props.tenantId, props.icpSelected, props.segmentName]
  );

  useEffect(() => {
    // let intentFillBody = [...intentSegmentBody];

    console.log("intentFillBody", props.requestBody)

    // setIntentFilterBodyToAH(intentFillBody);

    if (props.requestBody && props.segmentName && props.icpSelected) {
      displayIntentData([...props.requestBody, ...props.specialFilter]);
    }
  }, [
    props.requestBody,
    props.segmentName,
    props.icpSelected,
    displayIntentData,
  ]);

  return (
    
      <div
        className={styles.keySegmentContainer}
      >
        <KeySegmentTable
          column2={"Intent"}
          count={props?.count}
          rowsData={intentResult}
          tabVal={props.tabVal}
          icp={props.icpSelected}
          requestBody={props.requestBody}
          segmentName={props.segmentName}
          filterBodyToAH={intentFilterBodyToAH}
          category={props?.category}
        />
      </div>
  
  );
}

export default Intent_Segment;
